import services from './../../../services/service'; // Service Class
import SecondHeader from './../../Second-Header/index.vue'; // Second Header
import Sidebar from './../../Sidebar/index.vue'; // Sidebar
import MainFooter from './../../Main-Footer/index.vue'; // Main Footer
import SearchBar from '../../SearchBar.vue'; // Search Bar

let service = new services();

export default {
    name: 'CNInsurance',
    data () {
        return {
            user: {},
            cninsurance_listings:{},
            businesses: {},
            business: {},
            cnsurveys: {},
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            pag_intv: service.pageIntv,
            reviews: {},
            review: {},
            rate: "",
            has_reviewed: false,
            has_rated: false,
            current_page: 0,
            search_mode: false
        }
    },
    components: {
        'second-header': SecondHeader,
        'sidebar': Sidebar,
        'main-footer': MainFooter,
        'search-bar': SearchBar
    },
    computed: {
        rateValue: {
            get(){
                //this function will determine what is displayed in the input
                return this.rate;
            },
            set(newVal){
                //this function will run whenever the input changes
                if(this.user.user_id != null){
                    this.rate = newVal;
                    this.rateBusiness();
                }else{
                    localStorage.setItem("cn_prv_page","businesses");//log current page
                    this.preset();
                }
                
                
            }
        }
    },
    methods: {
        //settings
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        }else {
                            //this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                     //this.$router.push('login');
                    }
                })
            }else {
                //this.$router.push('login');
            }
            
        },

        //--//settings
        isActive(page){
            if(page == this.current_page){
                return true;
            }
        },
        
        //business
        setComponent(business) {
            this.business = business;
            this.panelFlag = true;
            //set has reviewed and has rated
            let reviews = this.business.business_reviews;
            reviews.forEach(function(element) {
                if(this.user.user_id == element.review_user_id){
                    this.has_reviewed = true;
                    console.log(999+element.review_user_id)
                }
            }, this);
            let rating = this.business.business_ratings;
            rating.forEach(function(element) {
                if(this.user.user_id == element.rate_user_id){
                    this.has_rated = true;
                }
            }, this);
                  
        },

        saveComponent(component) {
            this.cnpro = component;

            var credentials = {
                save_category: 2, // 2 for business
                save_business: this.business.business_id, //forbusiness
                save_cnpro: 0,
                save_user: this.user.user_id || 'nill'
            }
            service.saveListing(this, credentials).then(function(data) {
            if(data.body.status == 201) {
                toastr.success('Business Saved!!', 'Success!');
            }else if(data.body.status == 400) {
                toastr.error('Sorry, could not process information', 'Warning!');        
            }else if(data.body.status == 500) {
               toastr.error(data.body.message, 'Warning!');  
            }else {
                toastr.error('Please Log In to Save', 'Warning!');        
            }
            
            })
        },
       

        setBusiness() {
            var credentials = {
                data_item: localStorage.getItem("cityneeds_search_business")
            }
            localStorage.removeItem("cityneeds_search_business"); //remove
            localStorage.removeItem("cityneeds_search_city"); 
            localStorage.removeItem("cityneeds_search_keywords"); 
            localStorage.removeItem("cityneeds_search_type");
            service.getDataItem(this, credentials, 2).then(function(data) {
            if(data.body.status == 200) {
                //get the business
                service.getBusiness(this, data.body.data).then(data2 => {
                if(data2.body.status == 200) {
                    this.business = data2.body.data;
                    this.panelFlag = true;
                   
                }
                }).catch((err) => {
                    if(err) {
                        //toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
               
            }else if(data.body.status == 400) {
             //do something here like redirect to advertised data 
               this.search_message = "Sorry Could not get the Information of entry yet";            
            }
            })
           
        },

        getAllCNInsurance(offset,items) {
            let navi = this.$router;
            service.getCNinsuranceListings(this,offset,items).then(data => {
                if(data.body.status == 200) {
                    this.cninsurance_listings = data.body.data;
                    //check if single data
                    if(Object.keys(this.cninsurance_listings).length===1){
                        //navi.push("insuremoto-"+this.cninsurance_listings[0].cninsurance_url_name);
                        window.location.replace("/insuremoto-"+this.cninsurance_listings[0].cninsurance_url_name);
                    // navi.push("/"+this.cninsurance_listings[0].cninsurance_url_name)
                        //location.replace("cninsurance"+this.cninsurance_listings[0].cninsurance_url_name);
                    }
                 }
             }).catch((err) => {
                 if(err) {
                     //toastr.error('Sorry, could not process information', 'Warning!');
                 }
             })
        },

        getSearchBusinesses(offset,items) {
            var credentials = {
                search_type: 'businesses',
                search_keywords: this.$route.query.context,
                search_city: this.$route.query.city
            }
            //this.search_result = localStorage.getItem("cityneeds_search_keywords");
            this.search_result = this.$route.query.context;
            service.searchBusinesses(this, credentials,offset,items).then(function(data) {
                if(data.body.status == 200) {
                    this.businesses = data.body.data;
                    if((data.body.data_count % this.pag_intv)){
                        this.businesses.count_range = (Math.floor(data.body.data_count/this.pag_intv)+1);
                    }else{this.businesses.count_range = Math.floor(data.body.data_count/this.pag_intv);}
                     this.current_page = items;
                }else if(data.body.status == 400) {
                    //do something here like redirect to advertised data 
                    this.search_message = "Sorry Could not get the Information of entry yet";            
                }else{
                    this.search_message = "Sorry Could not get the Information of entry yet"; 
                }
            })
        },
        


        getBusiness(business) {
           service.getBusiness(this, business).then(data => {
                if(data.body.status == 200) {
                    this.business = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        doSearch(){
            var credentials = {
                search_type: this.search.type,
                search_keywords: this.search.keywords,
                search_city: this.search.city
            }

            let navi = this.$router;

            if(credentials.search_type != null || credentials.search_keywords != null) {
                if(credentials.search_type == "businesses") {
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                    navi.push("business-search");
                }
                 else if(credentials.search_type == "cnpros") {
                    //use local storage for now
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                    navi.push("cnpro-search");
                   
                }
           }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        
        },

    },
    created: function(){ 
        let u_t = localStorage.getItem("cityneeds_token");
        if((u_t != null)) {
            this.preset();
        }else{
            localStorage.setItem("cn_prv_page","businesses");//log current page
        }
        // this.getAllCNInsurance(0,this.pag_intv);
        this.getAllCNInsurance(0,1);
     }
}


// WEBPACK FOOTER //
// ./src/components/CNInsuranceSystem/CNInsurance/script.js